export default __webpack_public_path__ + "static/media/cool-cat.b9e77d6d45a4d5ed4e4a3cdcc2037f10.png";